import { jsxs as i, jsx as e, Fragment as x } from "react/jsx-runtime";
import { forwardRef as p, lazy as y, useState as _, useEffect as A, Suspense as I } from "react";
import { cn as C } from "@intergamma/common/cn";
import { Container as U } from "@intergamma/container";
import { WithoutDevices as B } from "@intergamma/devices";
import { isKiosk as K } from "@intergamma/kiosk-util";
import { useLegacyTheme as L } from "@intergamma/theme/provider";
import { dispatchAdobeEvent as s } from "@intergamma/adobe-tracking";
import { useTranslation as r } from "react-i18next";
import { useConfig as w } from "@intergamma/config";
import { ChevronUp as T, ChevronDown as S, Menu as F } from "react-feather";
import { L as O } from "./LoadingSearch-CoWrQPFm.js";
import { anchorStyle as z, Anchor as b } from "@intergamma/anchor";
import { PrivacyMask as G } from "@intergamma/privacy-mask";
import { UserGammaPro as R, UserKarwei as j, UserGamma as D, UserLoggedInKarwei as P, UserLoggedInGamma as E, UserLoggedOutKarwei as W, UserLoggedOutGamma as $, HeartKarwei as Y, HeartGamma as q, CartKarwei as J, CartGamma as Q } from "@intergamma/icons";
function X({ brandName: a, ...n }) {
  return /* @__PURE__ */ i("a", { ...n, children: [
    /* @__PURE__ */ e("span", { className: "sr-only", children: a }),
    /* @__PURE__ */ i(
      "svg",
      {
        width: "104",
        height: "42",
        viewBox: "0 0 104 42",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "pointer-events-none block select-none text-neutral-900 gamma:hidden karwei:text-functional-primary-900",
        children: [
          /* @__PURE__ */ e(
            "path",
            {
              d: "M102.319 18.6057C101.852 18.3062 104.516 16.3595 102.235 16.5592C101.769 16.5924 101.802 17.2746 101.819 17.624C101.436 16.842 100.837 16.243 100.137 15.9435C99.8543 14.5792 99.6212 13.1982 99.4214 11.8005C98.2226 10.6525 96.774 5.86058 95.6584 0.702637H49.5039V32.1994V41.9829H104V16.2264C102.951 16.9086 103.95 18.456 102.335 18.5891L102.319 18.6057Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ e("g", { opacity: "0.8", children: /* @__PURE__ */ e(
            "path",
            {
              d: "M49.4824 32.2155C51.4805 32.7979 53.4618 33.3802 55.9594 32.6315C55.9927 33.6465 56.0593 35.1938 57.4246 35.0774C61.5039 34.7446 66.2825 34.8611 69.1131 37.1905C69.829 38.1555 68.3472 40.0024 69.2296 40.252C70.6116 40.6513 71.9103 38.4883 73.2756 38.8876C73.642 30.9011 70.8281 23.68 69.7624 15.8432C68.2473 14.3957 66.3491 7.19118 65.1836 0.702148H49.4991V32.1989L49.4824 32.2155Z",
              fill: "#31A1A4"
            }
          ) }),
          /* @__PURE__ */ e("g", { opacity: "0.8", children: /* @__PURE__ */ e(
            "path",
            {
              d: "M96.1574 41.9994C93.6598 39.6201 90.03 21.5839 90.3131 16.8419C90.2798 16.7088 90.2299 16.5757 90.1966 16.4259C90.0967 13.8636 89.3141 10.8686 87.1995 8.98849C85.9341 8.1732 84.4189 7.35791 82.9703 6.55926C82.2544 7.12497 81.5218 7.67405 80.7892 8.15656C80.7559 7.12497 80.7059 6.11002 79.7901 5.84381C77.4425 3.98029 75.228 5.54431 72.0811 6.82548C70.7324 7.62413 68.4513 7.12497 67.1359 8.2564C67.1026 7.57422 67.1026 7.24144 67.0693 6.54262C65.704 6.65909 68.0517 8.52261 65.7706 8.37286C66.2035 7.6574 65.2711 7.04178 65.2378 6.3596C63.4229 6.85876 64.8715 8.78883 63.0566 8.93858C62.5904 8.63908 65.2545 6.69237 62.9734 6.89203C62.5072 6.92531 62.5405 7.60749 62.5571 7.9569C61.5747 5.97691 59.277 5.16162 57.0792 7.39119C57.0459 6.72565 57.8784 5.66078 57.4788 5.01188C57.4788 5.01188 57.4677 5.01188 57.4455 5.01188C57.4122 5.36129 57.0292 6.02683 57.0459 6.3596C57.0459 5.96028 57.0126 5.56095 56.9959 5.16163C56.6962 5.26146 56.3799 5.37793 56.0802 5.4944C55.8471 5.82717 55.6639 6.15994 55.6639 6.45943C55.6639 6.19321 55.6639 5.927 55.6306 5.66078C54.9313 5.96028 54.2486 6.29304 53.6159 6.62582C52.2839 7.75724 50.3025 8.95521 50.3192 9.45437C49.803 13.6473 49.6199 17.8236 50.0528 21.9166C50.8853 21.8002 51.7011 21.4674 52.134 21.7503C53.0831 22.6987 50.3858 23.9465 51.3348 24.8783C51.7844 24.845 52.2506 24.7951 52.7002 24.7618C52.2339 25.6603 51.6012 26.6253 51.0851 27.5737C51.5013 29.1544 52.0508 30.7018 52.7335 32.2325C53.2163 32.1161 53.6825 32.0329 53.8823 32.166C54.3319 32.7816 53.9989 33.7633 53.9822 34.745C54.0821 34.8781 54.182 35.0112 54.2819 35.1276C54.5983 35.1942 55.0645 35.1609 55.3642 35.1276C55.3642 35.5602 55.2976 35.9596 55.2143 36.3423C56.6463 38.1891 58.1614 40.0859 59.7432 41.9661H96.1574V41.9994Z",
              fill: "#31A1A4"
            }
          ) }),
          /* @__PURE__ */ e("g", { opacity: "0.8", children: /* @__PURE__ */ e(
            "path",
            {
              d: "M55.7289 41.9995H90.5612C87.7806 39.3539 83.8678 19.2213 84.1841 13.9136C84.1508 13.7639 84.0842 13.6141 84.0509 13.4477C83.9344 10.6025 83.0686 7.24155 80.6876 5.16173C79.2723 4.24661 77.5906 3.34813 75.9423 2.46629C75.1431 3.09855 74.3272 3.71418 73.5113 4.24661C73.478 3.09855 73.4114 1.96713 72.3958 1.66764C69.7817 -0.412179 67.2841 1.33487 63.7709 2.76578C62.2724 3.64763 59.7083 3.09856 58.2097 4.36309C58.1764 3.59771 58.1764 3.23166 58.1431 2.44965C56.628 2.58276 59.2421 4.64594 56.6946 4.47955C57.1774 3.6809 55.7622 2.99872 55.7289 2.23335C55.6123 2.26663 55.8288 2.2999 55.7289 2.34982V41.9995Z",
              fill: "#31A1A4"
            }
          ) }),
          /* @__PURE__ */ e("g", { opacity: "0.8", children: /* @__PURE__ */ e(
            "path",
            {
              d: "M55.4961 0.702637C55.6959 1.25171 55.929 1.7675 56.1621 2.29993C56.645 2.18346 57.1112 2.10027 57.311 2.23338C57.7605 2.84901 57.4275 3.83068 57.4109 4.81235C57.5108 4.94546 57.6107 5.07857 57.7106 5.19504C58.0269 5.2616 58.4931 5.22832 58.7928 5.19504C58.7928 5.62765 58.7262 6.02697 58.643 6.40965C61.9564 10.6858 65.7693 14.9785 69.5822 19.6872C70.9808 20.6023 72.3795 21.5175 73.0954 22.4658C73.828 23.9467 73.2286 26.0265 73.2786 27.5739C78.0239 26.6588 80.8878 30.0197 85.6164 28.6055C85.6497 29.6204 85.7163 31.1678 87.0817 31.0513C91.161 30.7186 95.9396 30.835 98.7701 33.1644C99.4861 34.1295 98.0042 35.9763 98.8867 36.2259C100.269 36.6252 101.567 34.4622 102.933 34.8616C103.299 26.8751 100.485 19.6539 99.4195 11.8172C98.2207 10.6691 96.7721 5.87722 95.6565 0.719271H55.5127L55.4961 0.702637Z",
              fill: "#31A1A4"
            }
          ) }),
          /* @__PURE__ */ e("g", { opacity: "0.8", children: /* @__PURE__ */ e(
            "path",
            {
              d: "M103.979 16.2442C102.93 16.9264 103.93 18.4738 102.314 18.6069C101.848 18.3074 104.512 16.3607 102.231 16.5603C101.765 16.5936 101.798 17.2758 101.815 17.6252C100.833 15.6452 98.5348 14.8299 96.337 17.0595C96.3037 16.3939 97.1362 15.3291 96.7366 14.6802C96.7366 14.6802 96.7255 14.6802 96.7033 14.6802C96.67 15.0296 96.287 15.6951 96.3037 16.0279C96.3037 15.6286 96.2704 15.2292 96.2537 14.8299C95.954 14.9298 95.6377 15.0462 95.338 15.1627C95.1049 15.4955 94.9217 15.8282 94.9217 16.1277C94.9217 15.8615 94.9217 15.5953 94.8884 15.3291C94.1891 15.6286 93.5064 15.9613 92.8737 16.2941C91.5417 17.4255 89.5603 18.6235 89.577 19.1227C89.0608 23.2989 88.8777 27.4918 89.3106 31.5849C90.1597 31.4685 90.9589 31.1357 91.3919 31.4185C92.3409 32.3669 89.6436 33.6148 90.5926 34.5466C91.0422 34.5133 91.5084 34.4634 91.958 34.4301C91.4918 35.3286 90.859 36.2936 90.3429 37.242C90.7758 38.8227 91.3086 40.42 91.9913 41.9507C92.4741 41.8343 92.9403 41.8176 93.1401 41.9507H103.996V16.1943L103.979 16.2442Z",
              fill: "#31A1A4"
            }
          ) }),
          /* @__PURE__ */ e(
            "path",
            {
              d: "M49.4845 41.9995H67.1338C66.9673 40.369 66.8007 38.7384 66.6842 37.0745C65.4021 34.6952 63.6372 16.8753 63.7704 12.1167C63.7537 11.9836 63.7204 11.8505 63.7038 11.7007C63.6538 9.13841 63.2542 6.14348 62.172 4.26332C61.5226 3.44803 60.7567 2.63274 60.0074 1.83409C59.6411 2.3998 59.2748 2.94888 58.8919 3.43139C58.8752 2.39981 58.8419 0.952252 58.3757 0.686035C55.8116 0.686035 56.0447 0.819144 54.4463 2.10031C53.7636 2.89896 52.5814 2.39981 51.9154 3.53123C51.8988 2.84905 51.8988 2.51627 51.8821 1.81745C51.1828 1.93392 52.3816 3.79744 51.2161 3.63105C51.4326 2.9156 50.9663 2.29997 50.9497 1.61779C50.0173 2.11695 51.1162 4.13021 50.1838 4.27996C49.9507 3.98047 50.9497 1.95056 49.7842 2.15022C49.5511 2.1835 49.4678 2.86568 49.4845 3.21509V41.9829V41.9995Z",
              fill: "#31A1A4"
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              opacity: "0.4",
              d: "M78.4239 29.1382C78.324 29.1548 78.2074 29.1715 78.1075 29.1881C78.1075 29.2214 78.1075 29.2547 78.1075 29.2879C78.2407 29.238 78.3406 29.1881 78.4405 29.1382M76.3259 29.3711C76.1761 29.3711 76.0096 29.4044 75.8597 29.4044C75.7265 30.1864 75.3768 31.1514 75.6599 31.2346C76.4924 30.7521 76.4258 30.0699 76.3259 29.3545M74.6609 29.5541C74.5277 29.5708 74.3945 29.6041 74.2613 29.6207C74.4611 29.7871 74.6609 30.0034 74.844 30.2197C74.7941 30.0367 74.7108 29.8037 74.6775 29.5541M63.9381 30.1199C61.0576 30.1199 57.8608 31.5674 55.0469 33.198C56.9617 37.3077 58.7099 37.2744 59.8755 41.9998H65.2701C64.5542 39.2378 63.9548 40.6188 63.4386 37.7237C63.2388 37.0914 64.7706 34.6622 65.6697 32.6156C66.0693 32.0167 66.5189 31.4343 66.9851 30.852C66.9518 30.802 66.9019 30.7521 66.8519 30.7188C65.9362 30.2862 64.9538 30.1032 63.9381 30.1032",
              fill: "#76B9BC"
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              d: "M0 0.702637H53.6805V41.9829H14.4524V21.3344H0V0.702637Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              d: "M0 0.702637V21.3344H17.5161C17.8824 21.3344 18.4651 21.2845 18.4651 21.8169C18.4651 22.3494 17.7159 22.2329 17.7159 22.8485C17.7159 23.4642 17.7492 23.0981 17.7991 23.2645L19.4475 29.3376L18.3486 33.7301H16.3839L14.4524 26.692V41.9995H53.6971V0.702637H0ZM33.9998 21.3677H37.613V24.6954C37.613 24.8285 37.5464 25.0615 37.1301 25.0615C36.7138 25.0615 36.7971 24.9117 36.7138 24.6788C36.2643 23.2978 35.3818 22.5158 33.9832 22.2828V21.3677H33.9998ZM33.9998 26.8917C34.5826 26.7253 34.9656 26.2262 35.1654 25.4109C35.2486 25.128 35.3485 24.8951 35.6649 24.8951C35.9812 24.8951 35.8813 24.9284 35.9479 24.9949C36.0811 25.1447 36.0811 25.4109 36.0645 25.5273V29.2045C36.0645 29.3376 36.0811 29.6038 35.9479 29.7369C35.8147 29.87 35.7981 29.8367 35.6649 29.8367C35.3485 29.8367 35.2486 29.6038 35.1654 29.3209C34.9656 28.5056 34.5826 28.0065 33.9998 27.8401V26.8917ZM25.2252 6.92545H28.8216L31.3025 17.3578L31.3358 17.4909C31.4191 17.8903 31.469 18.1731 31.9019 18.3561C32.1517 18.456 32.3015 18.5724 32.3015 18.8386C32.3015 19.1049 32.2682 19.005 32.2183 19.0716C32.0518 19.238 31.7021 19.238 31.469 19.238H27.3064C26.9235 19.238 26.5239 19.1881 26.5239 18.8054C26.5239 18.4227 26.6071 18.4892 26.8236 18.3728C27.2565 18.1232 27.3397 17.9901 27.1899 17.3245L26.8569 16.0434V16.0101H24.4592L24.6757 15.1283H26.707V15.0783C26.6904 15.0783 25.0253 7.77402 25.0253 7.77402L25.2252 6.92545ZM21.2457 18.3561C21.329 18.3228 21.4122 18.2896 21.4955 18.2563C21.8285 18.0899 22.2947 17.7239 22.6277 16.4926C22.6277 16.4926 24.4426 9.85384 24.6091 9.27149L25.0253 11.0851L23.4769 16.7422C23.2105 17.7571 23.4436 18.0733 24.0263 18.3229C24.2927 18.4393 24.4925 18.5225 24.4925 18.8386C24.4925 19.1548 24.4592 19.0383 24.3926 19.1049C24.2428 19.2546 23.9264 19.2546 23.6933 19.2546H21.7619C21.329 19.2546 20.8628 19.2047 20.8628 18.7887C20.8628 18.5059 21.0126 18.456 21.2457 18.3561ZM12.6209 19.238H7.92552C7.92552 19.238 7.34276 19.238 7.34276 18.7555C7.34276 18.2729 7.45932 18.406 7.67577 18.3395C8.25853 18.1565 8.25853 18.04 8.25853 17.4576V8.68914C8.25853 8.10679 8.25853 7.99032 7.67577 7.80729C7.45932 7.74074 7.34276 7.59099 7.34276 7.39133C7.34276 6.92545 7.90887 6.90881 7.92552 6.90881H12.6209C12.6209 6.90881 13.2037 6.90881 13.2037 7.39133C13.2037 7.87385 13.0871 7.74074 12.8707 7.80729C12.2879 7.99032 12.2879 8.10679 12.2879 8.68914V17.4576C12.2879 18.04 12.2879 18.1565 12.8707 18.3395C13.0871 18.406 13.2037 18.5558 13.2037 18.7555C13.2037 19.238 12.6209 19.238 12.6209 19.238ZM18.6982 19.238H14.4691C14.1028 19.238 13.6199 19.238 13.6199 18.7555C13.6199 18.2729 13.8031 18.3894 13.9862 18.2896C14.1361 18.2064 14.3026 18.1398 14.3026 17.9402C14.3026 17.7405 14.2193 17.5575 14.1694 17.4244L13.1371 14.3462V14.2963C13.0205 13.9968 12.9206 13.6807 12.9206 13.3479C12.9206 13.0152 13.0538 12.8488 13.237 12.5992L13.3036 12.516L15.2183 9.78728C15.4514 9.47114 15.6513 9.13838 15.6513 8.72241C15.6513 8.30645 15.4514 8.04023 15.0019 7.84057L14.9186 7.80729C14.6855 7.70746 14.5024 7.64091 14.5024 7.35805C14.5024 7.0752 14.5357 7.10847 14.6189 7.04192C14.7688 6.89217 15.0185 6.89217 15.2516 6.89217H18.1155C18.565 6.89217 18.9647 6.92545 18.9647 7.40797C18.9647 7.89049 18.6816 7.87385 18.3819 7.97368H18.3652C17.3163 8.373 16.8834 8.95535 16.3006 9.754L16.1341 9.98694L15.8178 10.4195H15.8011V10.4528L18.4651 17.441C18.4818 17.4909 18.5151 17.5575 18.5317 17.6074C18.6483 17.9069 18.7316 18.1232 19.0646 18.2896C19.2977 18.406 19.4475 18.4892 19.4475 18.7887C19.4475 19.0882 19.4142 18.9884 19.3476 19.0549C19.2311 19.2546 18.9314 19.238 18.6982 19.238ZM23.2771 33.6802H21.3623L19.2144 25.7436L20.33 21.3843H22.1449L24.3094 29.6038L23.2771 33.6802ZM27.0067 22.183C26.1576 22.549 25.9411 23.1647 25.7247 23.98C25.7247 23.98 24.8255 27.524 24.6923 28.1063L24.2428 26.3925L24.8755 23.8136C24.8921 23.7637 24.8921 23.6971 24.9088 23.6472C24.9421 23.4808 24.992 23.3144 24.992 23.1147C24.992 22.6322 24.6757 22.4492 24.3926 22.2828C24.1595 22.1497 23.9597 22.0332 23.9597 21.7837C23.9597 21.5341 24.1595 21.3677 24.5758 21.3677H26.707C27.0234 21.3677 27.3564 21.401 27.3564 21.8003C27.3564 22.0166 27.2398 22.0832 27.0067 22.183ZM33.184 33.6802H28.8549C28.8549 33.6802 28.2722 33.6802 28.2722 33.1977C28.2722 32.7152 28.3887 32.8483 28.6052 32.7817C29.1879 32.5987 29.1879 32.4823 29.1879 31.8999V23.1314C29.1879 22.549 29.1879 22.4326 28.6052 22.2495C28.3887 22.183 28.2722 22.0332 28.2722 21.8336C28.2722 21.3677 28.8383 21.3511 28.8549 21.3511H33.184V33.6802ZM37.7462 30.3858V33.6802H34.0165V32.7817C35.3319 32.6154 36.3808 31.7002 36.8304 30.3692V30.3192C36.9469 30.0863 37.0468 29.8866 37.2966 29.8866C37.5464 29.8866 37.5464 29.9199 37.6296 30.0031C37.7129 30.0863 37.7462 30.3359 37.7462 30.3858ZM39.9773 19.238H35.2819C35.2819 19.238 34.6992 19.238 34.6992 18.7555C34.6992 18.2729 34.8157 18.406 35.0322 18.3395C35.6149 18.1565 35.6149 18.04 35.6149 17.4576V8.68914C35.6149 8.10679 35.6149 7.99032 35.0322 7.80729C34.8157 7.74074 34.6992 7.59099 34.6992 7.39133C34.6992 6.92545 35.2653 6.90881 35.2819 6.90881H39.611V17.4576C39.611 18.04 39.611 18.1565 40.1937 18.3395C40.4102 18.406 40.5267 18.5558 40.5267 18.7555C40.56 19.238 39.9939 19.238 39.9773 19.238ZM45.9714 32.7984C46.1878 32.8649 46.3044 33.0147 46.3044 33.2143C46.3044 33.6802 45.7383 33.6969 45.7216 33.6969H41.0429C41.0429 33.6969 40.4601 33.6969 40.4601 33.2143C40.4601 32.7318 40.5767 32.8649 40.7932 32.7984C41.3759 32.6154 41.3759 32.4989 41.3759 31.9165V23.148C41.3759 22.5657 41.3759 22.4492 40.7932 22.2662C40.5767 22.1996 40.4601 22.0499 40.4601 21.8502C40.4601 21.3843 41.0263 21.3677 41.0429 21.3677H45.7216C45.7216 21.3677 46.3044 21.3677 46.3044 21.8502C46.3044 22.3327 46.1878 22.1996 45.9714 22.2662C45.3886 22.4492 45.3886 22.5657 45.3886 23.148V31.9165C45.3886 32.4822 45.3886 32.6154 45.9714 32.7984ZM45.8049 18.9052C45.3054 19.3212 44.7559 19.4876 43.9567 19.4876C43.1575 19.4876 42.5747 19.2546 42.1085 18.8054C41.5757 18.2563 41.4592 17.5741 41.4592 16.7256V15.5941C41.4592 14.8787 41.4592 13.897 40.4435 13.7805V12.8654C41.3759 12.7656 41.4592 12.1333 41.4592 11.3846V9.38795C41.4592 8.5893 41.3093 8.1567 40.4435 7.84057V6.92545H40.6932C41.7089 6.92545 42.7579 6.92545 43.6736 7.37469C44.7559 7.90712 45.322 8.8056 45.3387 10.0535C45.372 11.7007 44.4562 12.6824 42.4415 13.1483H42.4082V13.2481H42.4415C43.9234 13.4644 45.2887 13.897 45.322 15.6108V17.1415C45.322 17.2746 45.3054 17.441 45.3886 17.5408C45.4219 17.5741 45.4719 17.5908 45.5218 17.5908C45.655 17.5908 45.7383 17.4909 45.8215 17.3745C45.9214 17.2413 46.0213 17.1082 46.2211 17.1082C46.4209 17.1082 46.6707 17.3578 46.6707 17.5575C46.704 18.0234 46.1545 18.639 45.8049 18.9052Z",
              fill: "#1D1E1C"
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              d: "M78.3663 24.3796C78.3663 25.7772 78.1665 27.0584 77.7502 28.2231C77.3506 29.3878 76.7512 30.3861 75.9686 31.2347C75.1861 32.0666 74.2203 32.7322 73.0715 33.198C71.9226 33.6639 70.6239 33.8969 69.142 33.8969C67.6601 33.8969 66.6112 33.6972 65.5289 33.3145C64.43 32.9152 63.4976 32.3661 62.6984 31.634C61.8992 30.9186 61.2664 30.0367 60.8002 29.0218C60.334 28.0068 60.051 26.8754 59.9844 25.6275H64.7463C64.7963 26.9419 65.2292 27.9569 66.0617 28.6391C66.8942 29.3213 67.9266 29.6707 69.2086 29.6707C70.4907 29.6707 70.6738 29.5376 71.2233 29.2713C71.7894 29.0051 72.239 28.6391 72.572 28.1732C72.905 27.7073 73.1547 27.1582 73.3212 26.526C73.4877 25.8937 73.5543 25.2115 73.5543 24.5127C73.5543 23.1151 73.2047 21.967 72.522 21.0685C71.8394 20.1701 70.7405 19.7208 69.2086 19.7208C67.6768 19.7208 67.6768 19.9038 66.9608 20.2865C66.2449 20.6692 65.6788 21.185 65.2459 21.8506H60.5671L61.1332 6.92578H77.2008V11.1852H65.2459L64.9462 17.2417C65.5622 16.6593 66.2782 16.2267 67.144 15.9439C67.9932 15.661 69.0088 15.5279 70.2076 15.5279C71.4065 15.5279 72.7052 15.7608 73.7375 16.2101C74.7698 16.6593 75.619 17.2916 76.3016 18.0736C76.9843 18.8556 77.5005 19.804 77.8668 20.8855C78.1998 21.967 78.3663 23.1484 78.3663 24.3796Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              d: "M89.8863 23.8142C89.8863 23.0322 89.853 22.2169 89.7697 21.3683C89.7031 20.5197 89.5033 19.7377 89.2036 19.0389C88.9039 18.3401 88.471 17.7744 87.8716 17.3251C87.2888 16.8759 86.4896 16.643 85.4573 16.643C84.425 16.643 83.6424 16.8759 83.043 17.3251C82.4603 17.7744 82.0107 18.3401 81.711 19.0389C81.4113 19.7377 81.2281 20.5031 81.1449 21.3683C81.0783 22.2169 81.0283 23.0322 81.0283 23.8142V26.859C81.0283 27.641 81.0616 28.4563 81.1449 29.3049C81.2115 30.1535 81.4113 30.9355 81.711 31.6343C82.0107 32.3331 82.4436 32.8988 83.043 33.3481C83.6258 33.7973 84.425 34.0302 85.4573 34.0302C86.4896 34.0302 87.2722 33.8139 87.8716 33.3481C88.4544 32.8988 88.9039 32.3331 89.2036 31.6343C89.5033 30.9355 89.6865 30.1701 89.7697 29.3049C89.8363 28.4563 89.8863 27.641 89.8863 26.859V23.8142ZM94.6316 25.3283C94.6316 26.3432 94.5983 27.3582 94.5151 28.3399C94.4485 29.3382 94.2986 30.2866 94.0821 31.2183C93.8657 32.1334 93.566 32.9987 93.1497 33.8139C92.7335 34.6292 92.2007 35.328 91.5347 35.9437C90.8686 36.5593 90.0361 37.0751 89.0704 37.5077C88.1047 37.9403 86.9059 38.14 85.4906 38.14C84.0753 38.14 82.8765 37.9237 81.9108 37.5077C80.9451 37.0751 80.1126 36.5593 79.4466 35.9437C78.7806 35.328 78.2311 34.6126 77.8315 33.8139C77.4152 33.0153 77.1155 32.1501 76.8991 31.2183C76.6826 30.3032 76.5494 29.3382 76.4662 28.3399C76.3996 27.3415 76.3496 26.3432 76.3496 25.3283C76.3496 24.3133 76.3829 23.2984 76.4662 22.3167C76.5494 21.335 76.6826 20.37 76.8991 19.4382C77.1155 18.5231 77.4152 17.6579 77.8315 16.8426C78.2477 16.044 78.7806 15.3285 79.4466 14.7129C80.1126 14.0973 80.9451 13.5815 81.9108 13.1489C82.8765 12.7163 84.0753 12.5166 85.4906 12.5166C86.9059 12.5166 88.1047 12.7329 89.0704 13.1489C90.0361 13.5815 90.8686 14.0973 91.5347 14.7129C92.2007 15.3285 92.7501 16.044 93.1497 16.8426C93.566 17.6413 93.8657 18.5065 94.0821 19.4382C94.2986 20.3534 94.4318 21.3184 94.5151 22.3167C94.5817 23.315 94.6316 24.3133 94.6316 25.3283Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              d: "M80.7156 9.93729C80.7156 10.3366 80.599 10.6694 80.3826 10.9023C80.1494 11.1353 79.8331 11.2684 79.4168 11.2684C79.0006 11.2684 79.0339 11.2351 78.884 11.1685C78.7342 11.102 78.601 11.0188 78.5011 10.919C78.2513 10.6694 78.1348 10.3033 78.1348 9.85409H78.884C78.884 9.95393 78.884 10.0538 78.9173 10.1702C78.9173 10.2701 78.9839 10.3533 79.0505 10.4364C79.1005 10.4864 79.1504 10.5196 79.217 10.5529C79.2836 10.5862 79.3502 10.6028 79.4335 10.6028C79.6166 10.6028 79.7332 10.5529 79.8331 10.4531C79.9163 10.3532 79.9663 10.2035 79.9663 10.0371V6.95898H80.7489L80.7156 9.93729Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              d: "M84.4943 11.1853L84.2112 10.37H82.5129L82.2298 11.1853H81.4473L82.9458 6.90918H83.7949L85.2935 11.1853H84.4943ZM83.362 7.87421L82.746 9.67118H83.9615L83.362 7.87421Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              d: "M89.34 11.1853L89.0569 10.37H87.3586L87.0755 11.1853H86.293L87.7915 6.90918H88.6407L90.1392 11.1853H89.34ZM88.2077 7.87421L87.5917 9.67118H88.8072L88.2077 7.87421Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              d: "M93.5531 11.1853L92.8371 9.57135H91.888V11.1853H91.1055V6.90918H92.9037C93.1534 6.90918 93.3699 6.94246 93.5697 7.02565C93.7529 7.09221 93.9194 7.19203 94.0359 7.32514C94.1525 7.45825 94.2524 7.59136 94.3023 7.74111C94.3689 7.89085 94.3856 8.07388 94.3856 8.24026C94.3856 8.52312 94.319 8.7727 94.1691 8.989C94.0193 9.2053 93.8361 9.35505 93.603 9.43824L94.3856 11.1853H93.5531ZM93.6197 8.24026C93.6197 8.15707 93.6197 8.07388 93.5697 7.99068C93.5198 7.90749 93.4865 7.84094 93.4365 7.79102C93.3699 7.72447 93.3033 7.67455 93.22 7.65791C93.1368 7.62464 93.0369 7.608 92.9203 7.608H91.888V8.88917H92.9203C93.1368 8.88917 93.32 8.83925 93.4365 8.72278C93.5531 8.60631 93.6197 8.43993 93.6197 8.24026Z",
              fill: "white"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ i(
      "svg",
      {
        className: "pointer-events-none block h-10 w-[112px] select-none text-brand-primary karwei:hidden",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 112 40",
        focusable: "false",
        children: [
          /* @__PURE__ */ e("path", { fill: "currentColor", d: "M0 0h112v40H0z" }),
          /* @__PURE__ */ e(
            "path",
            {
              fill: "#FFF",
              d: "M103 27.9H89c-.68 0-1.25-.57-1.25-1.3v-7.98c0-.72.57-1.3 1.26-1.3h6.4v2.64h-3.8v5.3h6.35v-10.6H91.6V12h10.16c.7 0 1.26.6 1.26 1.32v14.6M82.7 12h-14c-.7 0-1.25.6-1.25 1.32v14.6h3.8V14.64h2.55v5.3h2.54v-5.3h2.54V27.9h5.08V13.33c0-.73-.56-1.32-1.26-1.32m-20.33 0h-14c-.68 0-1.25.6-1.25 1.35v14.6h3.8v-13.3h2.55v5.3H56v-5.3h2.54V27.9h5.08V13.33c0-.73-.57-1.32-1.27-1.32M43.3 27.9h-14c-.7 0-1.25-.57-1.25-1.3v-7.98c0-.72.56-1.3 1.26-1.3h6.4v2.64h-3.8v5.3h6.35v-10.6H31.9V12h10.16c.7 0 1.26.6 1.26 1.32v14.6M16.62 17.3v2.66h3.8v5.3H14.1v-10.6h10.17V12h-14c-.7 0-1.25.6-1.25 1.32V26.6c0 .73.56 1.3 1.26 1.3h13.98V17.3h-7.62"
            }
          )
        ]
      }
    )
  ] });
}
const e1 = y(
  () => import("@intergamma/kiosk-ui").then((a) => ({
    default: a.KioskController
  }))
), a1 = p(
  function({ formula: n, children: t, variant: o }, l) {
    const { t: g } = r("ig-header"), [m, c] = _(!1), f = L();
    return A(() => {
      K().then(c);
    }, []), /* @__PURE__ */ e(B, { devices: ["app"], children: /* @__PURE__ */ i(x, { children: [
      m && /* @__PURE__ */ e(I, { fallback: null, children: /* @__PURE__ */ e(e1, { formula: n }) }),
      /* @__PURE__ */ e(
        "div",
        {
          className: "relative bg-white py-[10px] shadow-[0_1px_3px_rgba(0,0,0,0.3)]",
          ref: l,
          children: /* @__PURE__ */ e(U, { children: /* @__PURE__ */ i(
            "div",
            {
              className: C(
                "relative flex h-[105px] w-full items-end justify-between gap-x-[10px]",
                o === "simple" && "h-auto !items-center"
              ),
              children: [
                /* @__PURE__ */ e(
                  X,
                  {
                    className: C(
                      "absolute left-0 top-0 z-[3] mx-0 my-[5px] lg:bottom-0 lg:top-auto",
                      "outline-none ring-offset-1 focus-visible:ring-3 focus-visible:ring-functional-focus-400",
                      o === "simple" && "relative"
                    ),
                    href: g("/www"),
                    brandName: f.brandName,
                    onClick: () => {
                      s({
                        type: "header",
                        data: { user_selected_element: "Logo" }
                      });
                    }
                  }
                ),
                t
              ]
            }
          ) })
        }
      )
    ] }) });
  }
), n1 = p(
  function({ className: n, children: t, ...o }, l) {
    return /* @__PURE__ */ e(
      "nav",
      {
        className: C(
          "relative inset-x-0 bottom-0 pl-0 lg:h-[46px] lg:data-[state=closed]:z-[2] lg:data-[state=open]:z-[1000] lg:gamma:pl-[117px] lg:karwei:pl-[109px]",
          n
        ),
        ...o,
        ref: l,
        children: t
      }
    );
  }
), N = C(
  "relative flex h-[46px] whitespace-nowrap rounded-[4px] p-1 leading-[22px] text-brand-primary no-underline antialiased gamma:items-center gamma:text-base gamma:font-normal karwei:items-end karwei:text-[1.1rem] karwei:font-bold",
  "hover:text-brand-primary hover:underline",
  "outline-none ring-offset-1 focus-visible:ring-3 focus-visible:ring-functional-focus-400",
  "[&>svg]:ml-[5px] [&>svg]:align-text-bottom gamma:[&>svg]:stroke-[2px] karwei:[&>svg]:stroke-[3px]"
);
function h({
  className: a,
  children: n,
  ...t
}) {
  return /* @__PURE__ */ e("a", { className: C(N, a), ...t, children: n });
}
function d({
  className: a,
  children: n,
  ...t
}) {
  return /* @__PURE__ */ e(
    "li",
    {
      className: C("float-left m-0 align-top lg:mx-[5px] lg:my-0", a),
      ...t,
      children: n
    }
  );
}
function t1() {
  const { t: a } = r("ig-header");
  return /* @__PURE__ */ i(x, { children: [
    /* @__PURE__ */ e(d, { children: /* @__PURE__ */ e(
      h,
      {
        href: a("/advice"),
        onClick: () => {
          s({
            type: "header",
            data: {
              user_selected_element: "Advies"
            }
          });
        },
        children: a("Advice").toLowerCase()
      }
    ) }),
    /* @__PURE__ */ e(d, { className: "karwei:hidden", children: /* @__PURE__ */ e(h, { href: a("/services"), children: a("Services").toLowerCase() }) }),
    /* @__PURE__ */ e(d, { children: /* @__PURE__ */ e(
      h,
      {
        href: a("/promotions"),
        onClick: () => {
          s({
            type: "header",
            data: {
              user_selected_element: "Actie"
            }
          });
        },
        children: a("Promotions").toLowerCase()
      }
    ) }),
    /* @__PURE__ */ e(d, { className: "gamma:hidden", children: /* @__PURE__ */ e(
      h,
      {
        href: a("/inspiration"),
        onClick: () => {
          s({
            type: "header",
            data: {
              user_selected_element: "Wooninspiratie"
            }
          });
        },
        children: a("Inspiration").toLowerCase()
      }
    ) })
  ] });
}
function i1({
  className: a,
  children: n,
  ...t
}) {
  return /* @__PURE__ */ e(
    "ul",
    {
      className: C("m-0 flex list-none items-center p-0", a),
      ...t,
      children: n
    }
  );
}
function C1({
  isOpen: a
}) {
  const { t: n } = r("ig-header");
  return /* @__PURE__ */ i("span", { className: C(N, "gap-x-0.5 border-none p-1 pl-2"), children: [
    /* @__PURE__ */ e("small", { className: "absolute top-[6px] text-[0.75em] font-normal leading-none gamma:hidden karwei:block", children: n("ViewOur").toLowerCase() }),
    /* @__PURE__ */ e("span", { children: n("Catalog").toLowerCase() }),
    /* @__PURE__ */ e("div", { className: "grid h-[22px] place-items-center", children: a ? /* @__PURE__ */ e(T, { className: "size-4 karwei:stroke-[3px]" }) : /* @__PURE__ */ e(S, { className: "size-4 karwei:stroke-[3px]" }) })
  ] });
}
const o1 = p(function(n, t) {
  const { t: o } = r("ig-header");
  return /* @__PURE__ */ i(
    "button",
    {
      className: C(
        "relative z-[2] flex items-center rounded-[4px] border px-[3px] text-center text-[0.75em] no-underline hover:text-black gamma:h-[46px] karwei:h-10",
        "gamma:border-[#a1b5c5] gamma:p-[6px_12px_6px_9px] gamma:text-[#51646f] karwei:border-[#dce1e8] karwei:p-[4px_12px_4px_9px] karwei:text-[#5b6573]",
        "outline-none ring-offset-1 focus-visible:ring-3 focus-visible:ring-functional-focus-400"
      ),
      ref: t,
      ...n,
      children: [
        /* @__PURE__ */ e(F, { className: "size-8 stroke-1" }),
        /* @__PURE__ */ e("span", { className: "inline-block truncate text-75 leading-none", children: o("Menu") })
      ]
    }
  );
});
function r1() {
  const { t: a } = r("ig-header"), { isMobile: n } = w();
  return /* @__PURE__ */ e(n1, { "aria-label": a("MainNavigation"), children: /* @__PURE__ */ i(i1, { children: [
    /* @__PURE__ */ e(d, { children: n ? /* @__PURE__ */ e(o1, {}) : /* @__PURE__ */ e(C1, { isOpen: !1 }) }),
    !n && /* @__PURE__ */ e(t1, {})
  ] }) });
}
function l1({ children: a, variant: n }) {
  return /* @__PURE__ */ e(
    "div",
    {
      className: C(
        "absolute right-0 top-0 flex h-[46px] items-center gap-2 lg:relative lg:h-[46px]",
        n === "simple" && "relative top-0"
      ),
      children: a
    }
  );
}
function u({ className: a, ...n }) {
  return /* @__PURE__ */ e(
    "div",
    {
      className: C(
        "inline-block h-[0.6em] animate-pulse rounded-[2em] bg-neutral-100",
        a
      ),
      ...n
    }
  );
}
const v = C(
  "relative inline-flex items-center rounded-[4px] text-right text-[0.92em] leading-6 text-brand-primary no-underline",
  "hover:underline",
  "outline-none ring-offset-1 focus-visible:ring-3 focus-visible:ring-functional-focus-400",
  "[&>svg]:ml-[2px] [&>svg]:stroke-[3px] [&>svg]:align-text-bottom"
);
function H({
  className: a,
  children: n,
  ...t
}) {
  return /* @__PURE__ */ e("a", { className: v, ...t, children: n });
}
const s1 = p(
  function({ onClick: n, user: t, href: o, isLoading: l }, g) {
    const { t: m } = r("ig-header"), { brandName: c } = L(), f = o ? "a" : "button", V = c === "Karwei" ? P : E, k = c === "Karwei" ? W : $, M = t != null && t.isLoggedIn ? V : k, Z = l ? c === "Karwei" ? j : D : M;
    return /* @__PURE__ */ i(
      f,
      {
        className: C(
          z,
          "flex h-8 items-center gap-[14px] leading-6 no-underline"
        ),
        href: o,
        onClick: n,
        ref: g,
        "data-testid": "header-login-button",
        children: [
          /* @__PURE__ */ e(
            "span",
            {
              className: C(
                v,
                "group hidden p-0 text-75 font-bold hover:no-underline lg:flex lg:flex-col lg:justify-center"
              ),
              children: l ? /* @__PURE__ */ e(u, { className: "w-[60px]" }) : /* @__PURE__ */ i(x, { children: [
                t != null && t.isLoggedIn ? m("Welcome") : m("loginTitle"),
                (t == null ? void 0 : t.isLoggedIn) && /* @__PURE__ */ e(G, { children: /* @__PURE__ */ e(
                  "span",
                  {
                    className: C(
                      v,
                      "block max-w-[200px] overflow-hidden text-ellipsis p-0 text-center text-75 font-normal group-hover:no-underline"
                    ),
                    children: t.firstName
                  }
                ) })
              ] })
            }
          ),
          (t == null ? void 0 : t.gammaPro) === !0 ? /* @__PURE__ */ e(R, {}) : /* @__PURE__ */ e(Z, {})
        ]
      }
    );
  }
);
function c1() {
  const { t: a } = r("ig-header"), { brandName: n } = L();
  return /* @__PURE__ */ i(
    b,
    {
      href: a("/favorites"),
      onClick: () => {
        s({
          type: "header",
          data: { user_selected_element: "Favorites" }
        });
      },
      children: [
        /* @__PURE__ */ e("span", { className: "sr-only", children: a("Favorites") }),
        n === "Karwei" ? /* @__PURE__ */ e(Y, {}) : /* @__PURE__ */ e(q, {})
      ]
    }
  );
}
function d1({
  numberOfProducts: a
}) {
  const { t: n } = r("ig-header"), { SHOPFRONT_URL: t, brand: o } = w(), l = `${t}${n("/cart")}`;
  return /* @__PURE__ */ i(
    b,
    {
      className: "relative px-0",
      href: l,
      onClick: () => {
        s({
          type: "header",
          data: { user_selected_element: "Cart" }
        });
      },
      children: [
        /* @__PURE__ */ e("span", { className: "sr-only", children: n("Cart") }),
        o === "karwei" ? /* @__PURE__ */ e(J, {}) : /* @__PURE__ */ e(Q, {}),
        a > 0 && /* @__PURE__ */ e("span", { className: "absolute -right-2 -top-2 grid h-5 min-w-5 place-items-center rounded-full bg-brand-conversion px-0.5 text-[12px] leading-none text-white", children: a > 99 ? "99+" : a })
      ]
    }
  );
}
function m1() {
  return /* @__PURE__ */ i(l1, { children: [
    /* @__PURE__ */ e(s1, { isLoading: !0 }),
    /* @__PURE__ */ e(c1, {}),
    /* @__PURE__ */ e(d1, { numberOfProducts: 0 })
  ] });
}
function h1() {
  const { t: a, i18n: n } = r("ig-header");
  return /* @__PURE__ */ i("ul", { className: "absolute right-[115px] top-0 m-0 hidden h-[46px] list-none items-center p-0 lg:right-0 lg:flex", children: [
    n.languages.length > 0 && /* @__PURE__ */ e("li", { className: "m-0 inline-block p-0 align-top", children: /* @__PURE__ */ e(H, { children: /* @__PURE__ */ e(u, { className: "w-[120px]" }) }) }),
    /* @__PURE__ */ e("li", { className: "m-0 inline-block p-0 align-top", children: /* @__PURE__ */ e(H, { href: a("/stores/search"), children: /* @__PURE__ */ e(u, { className: "w-[120px]" }) }) })
  ] });
}
function _1() {
  return /* @__PURE__ */ i(a1, { formula: {
    id: "gamma_nl",
    baseDomain: "acceptatie.gamma.nl",
    brand: "gamma",
    brandName: "GAMMA",
    CHECKOUT_URL: "kassa.acceptatie.gamma.nl",
    MYACCOUNT_URL: "mijn.acceptatie.gamma.nl",
    SHOPFRONT_URL: "www.acceptatie.gamma.nl"
  }, children: [
    /* @__PURE__ */ e(r1, {}),
    /* @__PURE__ */ e(O, {}),
    /* @__PURE__ */ e(h1, {}),
    /* @__PURE__ */ e(m1, {})
  ] });
}
export {
  n1 as B,
  d1 as C,
  c1 as F,
  a1 as H,
  l1 as I,
  _1 as L,
  u as S,
  H as T,
  s1 as U,
  i1 as a,
  d as b,
  o1 as c,
  C1 as d,
  t1 as e,
  r1 as f,
  m1 as g,
  h1 as h,
  v as t
};
